export const DATE_FORMAT = "MM-DD-YYYY";
export const DATE_AND_TIME_FORMAT = "MM-DD-YYYY, hh:mm a";
export const BASE_DOMAINS = [
    "localhost",
    "stg.viptravelreward.com",
    "viptravelreward.com",
];
